<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-lg-2">
          <div class="JY-sonnav">
            <ul>
              <li @click="gotoSubNav('/driver/search')" :class="selSubNav=='/driver/search'?'sel':''">
                <router-link to="search">
                  <i>
                    <img src="../../assets/images/icon-3.png" width="44" height="44" alt />
                  </i>
                  <i class="is">
                    <img src="../../assets/images/icon-3-sel.png" width="44" height="44" alt />
                  </i>
                  <br />货源搜索
                </router-link>
                <span></span>
              </li>
              <li @click="gotoSubNav('/driver/agreement')" :class="selSubNav=='/driver/agreement'?'sel':''">
                <router-link to="agreement">
                  <i>
                    <img src="../../assets/images/icon-6.png" width="44" height="44" alt />
                  </i>
                  <i class="is">
                    <img src="../../assets/images/icon-6-sel.png" width="44" height="44" alt />
                  </i>
                  <br />我的协议
                </router-link>
                <span></span>
              </li>
              <li id="driver-orders" @click="gotoSubNav('/driver/orders')" :class="selSubNav=='/driver/orders'?'sel':''">
                <router-link to="orders">
                  <i>
                    <img src="../../assets/images/icon-4.png" width="44" height="44" alt />
                  </i>
                  <i class="is">
                    <img src="../../assets/images/icon-4-sel.png" width="44" height="44" alt />
                  </i>
                  <br />我的运单
                </router-link>
                <span></span>
              </li>
              <li id="driver-complaints" @click="gotoSubNav('/driver/complaints')" :class="selSubNav=='/driver/complaints'?'sel':''">
                <router-link to="complaints">
                  <i>
                    <img src="../../assets/images/icon-complaints.png" width="44" height="44" alt />
                  </i>
                  <i class="is">
                    <img src="../../assets/images/icon-complaints-sel.png" width="44" height="44" alt />
                  </i>
                  <br />投诉建议
                </router-link>
                <span></span>
              </li>
            </ul>
          </div>
        </div>
        <router-view />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      selSubNav: this.$router.currentRoute.path
    };
  },
  methods: {
    gotoSubNav(nav) {
      this.selSubNav = nav;
    }
  },
  mounted() {}
};
</script>
<style>
  .JY-sonnav li {
    padding: 0;
    width: 100px;
    height: 100px;
  }
  .JY-sonnav li a {
    display: block;
    height: 100%;
    width: 100%;
    padding-top: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Driver/Index.vue